<template>
	<div class="add-ip">
		<managing-section>
			<managing-box :title="contsTitle">
				<select
					class="select"
					ref="value"
					v-if="selectList"
					v-model="value"
				>
					<option
						v-for="item in selectList"
						:key="item.idRegister"
						:value="item.idRegister"
						:disabled="!item.idRegister"
					>
						{{
							item.idRegister
								? `${item.nickName}(${item.eMail})`
								: params.placeholder
						}}
					</option>
				</select>
				<input
					type="text"
					ref="value"
					v-else
					:placeholder="params.placeholder"
					v-model="value"
				/>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button class="btn-main blue" type="button" @click="add">
				추가
			</button>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'AddIp',
		components: { ManagingSection, ManagingBox },
		data() {
			return {
				value: null,
			};
		},
		computed: {
			...mapState({
				contsTitle: state => state.modal.contsTitle,
				params: state => state.modal.params || {},
			}),
			selectList() {
				const selectList = this.params.selectList;
				let list = null;
				if (Array.isArray(selectList)) {
					const placeholder = this.params.placeholder;
					list = placeholder
						? [
								{ idRegister: null, name: placeholder },
								...selectList,
							]
						: selectList;
				}
				return list;
			},
		},
		methods: {
			async add() {
				try {
					const params = this.params;
					const type = params.type;
					if (!this.value) {
						alert(params.alertMsg);
						this.$refs.value.focus();
						return;
					}
					const body = { ip: this.value, status: params.type };
					const { data } = await this.$axiosSupport.post(
						'/admin/iptables',
						body
					);
					window.location.reload();
				} catch (err) {
					console.error(err);
					let msg = err.response.data.error.message;
					if (!msg)
						msg = '추가하는데 실패했습니다. 개발팀에 문의하세요.';
					alert(msg);
				}
			},
		},
	};
</script>
